export const textCall = {
    BEFORE_ACTIVE_TIMER: 'Вызов...',
    FAILED_CALL: 'Не удалось дозвониться',
    CANCELLED_CALL: 'Вызов завершён',
};
